export function receiptToScoreSummary(receipt) {
  return {
    totalPoints: receipt.points,
    basePoints: receipt.base_points,
    streakBonus: receipt.streak_bonus,
    comebackBonus: receipt.comeback_bonus,
    fastBonus: receipt.fast_bonus,
    powerPlayMultiplier: receipt.power_play_multiplier,
    answeredCorrect: receipt.answered_correct,
  };
}

export function mergeQuestionFeedback(questions, rows) {
  const byId = new Map(rows.map((q) => [q.id, q]));
  return questions.map((q) => {
    const fresh = byId.get(q.id);
    if (!fresh) return q;
    return {
      ...q,
      correct_answer: fresh.correct_answer || [],
      explanation: fresh.questions_v2?.explanation || '',
      tipCorrect: fresh.questions_v2?.tip_correct || '',
      tipWrong: fresh.questions_v2?.tip_wrong || '',
      tipCloseCall: fresh.questions_v2?.tip_close_call || '',
    };
  });
}
